// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3r0iB","itemTitle":"ClientEmergencyInfo_itemTitle__3SzYH","itemText":"ClientEmergencyInfo_itemText__uiW2I"};